import { buildLocalizedOfferContent } from '../appRouteOfferCore.js';
import APP_ROUTE_OFFER_COPY_HI from './appRouteOfferContent.hi.js';

// Only this locale's offer copy: appRouteSeo.js imports some of these
// content files into the shared client chunk.
const OFFER_CONTENT = buildLocalizedOfferContent(APP_ROUTE_OFFER_COPY_HI, 'hi');

export const APP_ROUTE_SEO_CONTENT_HI = {
  "/metadata": {
    "title": "Metadata Studio",
    "intro": [
      "एक केंद्रित वर्कफ़्लो में स्टॉक फ़ोटो, वेक्टर और वीडियो कीवर्ड, शीर्षक और विवरण तैयार करें। Stocktag त्वरित रन के लिए इमेज-टू-कीवर्ड टूल और उत्पादन कार्य के लिए पूर्ण मेटाडेटा स्टूडियो दोनों के रूप में काम करता है।",
      "संपत्तियां अपलोड करें, आउटपुट की तुरंत समीक्षा करें, और अपने पोर्टफोलियो में स्थिरता खोए बिना CSV/XMP निर्यात करें।"
    ],
    "bullets": [
      "छवि-से-कीवर्ड, शीर्षक और विवरण वर्कफ़्लो एक बार में",
      "डुप्लिकेट और कमजोर टैग को साफ़ करने के लिए तेज़ समीक्षा उपकरण",
      "प्रमुख स्टॉक प्लेटफार्मों के लिए निर्यात-तैयार आउटपुट"
    ],
    "links": [
      {
        "href": "/pricing",
        "label": "मूल्य निर्धारण योजनाएं देखें"
      },
      {
        "href": "/blog",
        "label": "मेटाडेटा ब्लॉग पढ़ें"
      },
      {
        "href": "/free-credits",
        "label": "मुफ़्त क्रेडिट प्राप्त करें"
      }
    ],
    "sections": [
      {
        "title": "वर्कफ़्लो एक नज़र में",
        "paragraphs": [
          "एक बैच अपलोड करें, एक बार में शीर्षक, विवरण और कीवर्ड उत्पन्न करें, फिर फ़ाइल संदर्भ खोए बिना समीक्षा करें और निर्यात करें।"
        ],
        "bullets": [
          "साफ़ फ़ाइल नामों के साथ बैच अपलोड और संसाधित करें",
          "कीवर्ड क्रम, शीर्षक शब्दांकन और कमजोर टैग की समीक्षा करें",
          "मार्केटप्लेस अपलोड के लिए CSV या XMP निर्यात करें"
        ]
      },
      {
        "title": "यह किसके लिए है",
        "paragraphs": [
          "योगदानकर्ताओं, स्टूडियो और टीमों के लिए डिज़ाइन किया गया है जो बड़े पैमाने पर प्रकाशित करते हैं और बाज़ारों में विश्वसनीय स्टॉक शीर्षक और कीवर्ड वर्कफ़्लो की आवश्यकता होती है।"
        ],
        "bullets": [
          "बड़े पुस्तकालयों का प्रबंधन करने वाले निर्माता",
          "ऐसी टीमें जिन्हें दोहराए जाने योग्य मेटाडेटा नियमों की आवश्यकता होती है",
          "अनेक साइटों पर पोर्टफ़ोलियो प्रकाशन"
        ]
      }
    ],
    "faq": [
      OFFER_CONTENT.creditUsageFaq,
      {
        "q": "कौन से बाज़ार समर्थित हैं?",
        "a": "प्रमुख स्टॉक प्लेटफ़ॉर्म जैसे Adobe Stock, Shutterstock, Pond5, Getty, आदि समर्थित हैं।"
      }
    ]
  },
  "/market-intelligence": {
    "title": "Market Intelligence",
    "intro": [
      "शूट या डिज़ाइन से पहले स्टॉक कीवर्ड ट्रेंड और मौसमी माँग की रिसर्च करें। Trends Radar Google के नतीजे व सुझाव और Adobe Stock, Shutterstock जैसी स्टॉक साइटों के सर्च नतीजे पढ़ता है।",
      "तेजी से प्रकाशित करने और स्पष्ट खोज इरादे के साथ रैंक करने के लिए अंतर्दृष्टि को Metadata Studio के साथ जोड़ें।"
    ],
    "bullets": [
      "खरीदार खोजों में रुझान में बदलाव",
      "मौसमी योजना के लिए माइक्रोस्टॉक कैलेंडर का पालन करें",
      "श्रेणी के आधार पर सामग्री अंतराल को पहचानें",
      "वास्तविक मांग संकेतों के साथ उत्पादन की योजना बनाएं"
    ],
    "links": [
      {
        "href": "/metadata",
        "label": "Metadata Studio खोलें"
      },
      {
        "href": "/pricing",
        "label": "योजनाओं की तुलना करें"
      },
      {
        "href": "/blog",
        "label": "ट्रेंड गाइड का अन्वेषण करें"
      }
    ],
    "sections": [
      {
        "title": "शूट करने से पहले मांग का पता लगाएं",
        "paragraphs": [
          "Trends Radar दिखाता है कि किसी विषय में सर्च की रुचि किस दिशा में जा रही है। इसके लिए यह Google के नतीजों और सुझावों तथा स्टॉक साइटों के सर्च नतीजों का उपयोग करता है, ताकि आप साफ़ माँग संकेतों के साथ प्रोडक्शन की योजना बना सकें।"
        ],
        "bullets": [
          "मौसमी मांग बदलावों पर नज़र रखें",
          "उच्च-उद्देश्य वाले कीवर्ड जल्दी पहचानें",
          "उत्पादन से पहले अवधारणाओं को मान्य करें"
        ]
      },
      {
        "title": "अंतर्दृष्टि को मेटाडेटा में बदलें",
        "paragraphs": [
          "कीवर्ड सेट को ताज़ा करने और वास्तविक खरीदार के इरादे के साथ शीर्षक और विवरण संरेखित करने के लिए ट्रेंड सिग्नल और कैलेंडर योजना का उपयोग करें।"
        ],
        "bullets": [
          "पुराने पोर्टफोलियो को नई शर्तों के साथ ताज़ा करें",
          "मेटाडेटा को मांग संकेतों के साथ संरेखित करें",
          "पुन: प्रयोज्य टेम्पलेट्स के साथ तेजी से शिप करें"
        ]
      }
    ],
    "faq": [
      {
        "q": "ट्रेंड डेटा कहाँ से आता है?",
        "a": "Trends Radar सार्वजनिक सर्च सिग्नल से माँग का अनुमान लगाता है: किसी विषय के लिए Google के नतीजे और सुझाव, और Adobe Stock, Shutterstock, iStock व Getty Images जैसी बड़ी स्टॉक साइटों के सर्च नतीजे। यह किसी मार्केटप्लेस का आंतरिक सर्च डेटा इस्तेमाल नहीं करता।"
      },
      {
        "q": "रुझान कितनी बार अपडेट किए जाते हैं?",
        "a": "नए मांग संकेत सामने आने पर ट्रेंड स्नैपशॉट नियमित रूप से ताज़ा होते रहते हैं।"
      },
      {
        "q": "क्या इसमें माइक्रोस्टॉक कैलेंडर शामिल है?",
        "a": "हाँ. Market Intelligence में अवकाश और मौसमी योजना दृश्य शामिल हैं ताकि आप कीवर्ड अवसरों को सही उत्पादन विंडो में मैप कर सकें।"
      },
      {
        "q": "क्या यह हर योजना में शामिल है?",
        "a": "Holiday Planner साइन इन किए हर खाते में उपलब्ध है। Trends Radar और Similarity Scanner मासिक क्रेडिट प्लान में शामिल हैं।"
      }
    ]
  },
  "/free-credits": OFFER_CONTENT.freeCredits,
  "/image-generator": {
    "title": "Image Generator",
    "intro": [
      "स्टॉक वर्कफ़्लोज़, अवधारणा परीक्षण और कीवर्ड-टू-इमेज आइडिएशन के लिए संदर्भ दृश्य उत्पन्न करें। खोज अभिप्राय को तेजी से मान्य करने के लिए छवि आउटपुट को मेटाडेटा के साथ जोड़ें।",
      "शैलियों, रचनाओं और उपयोग के मामलों का परीक्षण करते समय अपनी उत्पादन पाइपलाइन को चालू रखें।"
    ],
    "bullets": [
      "तीव्र अवधारणा सत्यापन",
      "कीवर्ड-टू-इमेज विचार परीक्षण",
      "स्टॉक-तैयार परिसंपत्तियों के लिए स्टाइल अन्वेषण",
      "योजना के लिए वर्कफ़्लो-अनुकूल आउटपुट"
    ],
    "links": [
      {
        "href": "/metadata",
        "label": "मेटाडेटा उत्पन्न करें"
      },
      {
        "href": "/pricing",
        "label": "योजनाएं देखें"
      },
      {
        "href": "/blog",
        "label": "उत्पादन युक्तियाँ पढ़ें"
      }
    ],
    "sections": [
      {
        "title": "स्टॉक योजना के लिए मामलों का उपयोग करें",
        "paragraphs": [
          "पूर्ण शूट से पहले रचना, शैली, मौसमी अवधारणाओं या शीघ्र कीवर्ड का पता लगाने के लिए त्वरित दृश्य संदर्भ उत्पन्न करें।"
        ],
        "bullets": [
          "संकल्पना परीक्षण और मूडबोर्ड",
          "नए संग्रहों के लिए शैली अन्वेषण",
          "प्री-प्रोडक्शन योजना समर्थन"
        ]
      },
      {
        "title": "मेटाडेटा के साथ युग्मित करें",
        "paragraphs": [
          "Metadata Studio में कीवर्ड-टू-इमेज विचारों से इमेज-टू-कीवर्ड मेटाडेटा में जाने के लिए उत्पन्न अवधारणाओं का उपयोग करें ताकि उत्पादन संरेखित रहे।"
        ],
        "bullets": [
          "संकेतों को कीवर्ड अभिप्राय के साथ संरेखित करें",
          "प्री-प्रोडक्शन लेखन पर समय बचाएं",
          "प्रकाशन तैयारी में तेजी लाएं"
        ]
      }
    ],
    "faq": [
      {
        "q": "क्या यह स्टॉक-तैयार छवियां उत्पन्न करता है?",
        "a": "यह संदर्भ दृश्य उत्पन्न करता है। अंतिम सबमिशन के लिए प्लेटफ़ॉर्म नीतियों का पालन करें।"
      },
      {
        "q": "क्या मैं आउटपुट निर्यात कर सकता हूँ?",
        "a": "हाँ. योजना और मेटाडेटा तैयारी के लिए आउटपुट डाउनलोड करें।"
      }
    ]
  },
  "/vectorizer": {
    "title": "AI Vectorizer",
    "intro": [
      "स्टॉक लिस्टिंग के लिए रेखापुंज छवियों को साफ़ SVG वैक्टर में बदलें। मैन्युअल ट्रेसिंग समय कम करें और लाइन गुणवत्ता को सुसंगत रखें।",
      "बाज़ार के लिए तैयार परिसंपत्तियों को तेज़ी से भेजने के लिए मेटाडेटा के साथ-साथ वेक्टर आउटपुट का उपयोग करें।"
    ],
    "bullets": [
      "तेज़ रैस्टर-टू-वेक्टर रूपांतरण",
      "स्केलेबल परिसंपत्तियों के लिए साफ़ रास्ते",
      "बैच-अनुकूल वर्कफ़्लो"
    ],
    "links": [
      {
        "href": "/metadata",
        "label": "Metadata Studio खोलें"
      },
      {
        "href": "/pricing",
        "label": "योजनाओं की तुलना करें"
      },
      {
        "href": "/blog",
        "label": "वेक्टर वर्कफ़्लो युक्तियाँ"
      }
    ],
    "sections": [
      {
        "title": "साफ़ वेक्टर आउटपुट",
        "paragraphs": [
          "लाइन गुणवत्ता और किनारों को संरक्षित करते हुए रेखापुंज कलाकृति को SVG-तैयार संपत्तियों में परिवर्तित करें।"
        ],
        "bullets": [
          "मैन्युअल ट्रेसिंग समय कम करें",
          "लिस्टिंग के लिए स्केलेबल आउटपुट रखें",
          "साफ-सुथरे रास्ते बनाए रखें"
        ]
      },
      {
        "title": "वर्कफ़्लो फिट",
        "paragraphs": [
          "एक ही सत्र में शीर्षक और कीवर्ड उत्पन्न करने के लिए Metadata Studio के साथ वेक्टर आउटपुट का उपयोग करें।"
        ],
        "bullets": [
          "बैच-अनुकूल रूपांतरण",
          "लगातार फ़ाइल नामकरण",
          "निर्यात के लिए तैयार पाइपलाइन"
        ]
      }
    ],
    "faq": [
      {
        "q": "कौन से प्रारूप समर्थित हैं?",
        "a": "स्टॉक सबमिशन के लिए सामान्य रैस्टर इनपुट SVG-तैयार आउटपुट के साथ समर्थित हैं।"
      },
      {
        "q": "क्या बैच प्रोसेसिंग उपलब्ध है?",
        "a": OFFER_CONTENT.vectorizerAllowance
      }
    ]
  },
  "/prompter": {
    "title": "Prompter",
    "intro": [
      "लगातार परिसंपत्ति निर्माण और मेटाडेटा योजना के लिए संरचित संकेत बनाएं। आउटपुट को साफ़ और पुन: प्रयोज्य रखने के लिए शीघ्र टेम्पलेट का उपयोग करें।",
      "आपके रचनात्मक इरादे से मेल खाने वाले शीर्षक और कीवर्ड तैयार करने के लिए संकेतों को Metadata Studio के साथ जोड़ें।"
    ],
    "bullets": [
      "टेम्पलेट-संचालित प्रॉम्प्ट संरचना",
      "पुन: प्रयोज्य शीघ्र पुस्तकालय",
      "स्टॉक अवधारणाओं के लिए तेज़ पुनरावृत्ति"
    ],
    "links": [
      {
        "href": "/metadata",
        "label": "मेटाडेटा उत्पन्न करें"
      },
      {
        "href": "/pricing",
        "label": "योजना विकल्प देखें"
      },
      {
        "href": "/help",
        "label": "Prompter गाइड"
      }
    ],
    "sections": [
      {
        "title": "संरचित त्वरित डिज़ाइन",
        "paragraphs": [
          "Prompter आपको वेरिएबल के साथ दोहराए जाने योग्य संकेत बनाने में मदद करता है ताकि आपके आउटपुट सुसंगत रहें।"
        ],
        "bullets": [
          "टेम्पलेट-संचालित प्रॉम्प्ट संरचना",
          "पुन: प्रयोज्य शीघ्र पुस्तकालय",
          "नई अवधारणाओं के लिए तेज़ पुनरावृत्ति"
        ]
      },
      {
        "title": "मेटाडेटा के साथ एकीकृत करें",
        "paragraphs": [
          "मेटाडेटा भाषा को अपने रचनात्मक इरादे के साथ संरेखित रखने के लिए अपनी त्वरित लाइब्रेरी का उपयोग करें।"
        ],
        "bullets": [
          "क्लीनर कीवर्ड सेट",
          "बेहतर अवधारणा नामकरण",
          "सुसंगत विवरण"
        ]
      }
    ],
    "faq": [
      {
        "q": "क्या मैं शीघ्र टेम्पलेट सहेज सकता हूँ?",
        "a": "हाँ. टेम्प्लेट को प्रोजेक्ट और टीमों में पुन: उपयोग किया जा सकता है।"
      },
      {
        "q": "क्या यह Metadata Studio के साथ काम करता है?",
        "a": "आउटपुट को संरेखित रखने के लिए मेटाडेटा जेनरेशन के साथ संकेतों का उपयोग करें।"
      }
    ]
  },
  "/pricing": OFFER_CONTENT.pricing,
  "/help": {
    "title": "सहायता केंद्र",
    "intro": [
      "वर्कफ़्लो मार्गदर्शिकाएँ, सेटअप निर्देश और समस्या निवारण चरण ढूँढें। सहायता केंद्र मेटाडेटा, निर्यात और योजना उपयोग के माध्यम से चलता है।",
      "हाल के अपडेट और सुधारों को ट्रैक करने के लिए चेंजलॉग का उपयोग करें।"
    ],
    "bullets": [
      "त्वरित-प्रारंभ वर्कफ़्लो ट्यूटोरियल",
      "निर्यात और प्लेटफ़ॉर्म सेटअप मार्गदर्शिकाएँ",
      "अद्यतन रिलीज़ नोट्स"
    ],
    "links": [
      {
        "href": "/help/changelog",
        "label": "चेंजलॉग देखें"
      },
      {
        "href": "/metadata",
        "label": "Metadata Studio खोलें"
      },
      {
        "href": "/blog",
        "label": "वर्कफ़्लो युक्तियाँ पढ़ें"
      }
    ],
    "sections": [
      {
        "title": "आप क्या सीखेंगे",
        "paragraphs": [
          "मार्गदर्शिकाएँ मेटाडेटा निर्माण, निर्यात, प्लेटफ़ॉर्म प्रीसेट और समस्या निवारण को कवर करती हैं।"
        ],
        "bullets": [
          "मेटाडेटा वर्कफ़्लो सेटअप",
          "प्रारूप और अपलोड निर्यात करें",
          "खाता और बिलिंग की मूल बातें"
        ]
      },
      {
        "title": "लोकप्रिय शुरुआती बिंदु",
        "paragraphs": [
          "Metadata Studio गाइड से शुरुआत करें, फिर नवीनतम अपडेट के लिए चेंजलॉग की समीक्षा करें।"
        ],
        "bullets": [
          "Metadata Studio वॉकथ्रू",
          "प्लेटफ़ॉर्म निर्यात युक्तियाँ",
          "नोट जारी करें और अपडेट करें"
        ]
      }
    ],
    "faq": [
      {
        "q": "मुझे कहाँ से शुरू करना चाहिए?",
        "a": "Metadata Studio गाइड से शुरुआत करें और चरण-दर-चरण वर्कफ़्लो का पालन करें।"
      },
      {
        "q": "समर्थन चाहिए?",
        "a": "सहायता केंद्र का उपयोग करें या ऐप के अंदर से टीम से संपर्क करें।"
      }
    ]
  },
  "/help/changelog": {
    "title": "चेंजलॉग",
    "intro": [
      "Stocktag में हाल के सुधारों और अपडेट को ट्रैक करें। प्रत्येक रिलीज़ नई सुविधाओं, सुधारों और वर्कफ़्लो संवर्द्धनों पर प्रकाश डालती है।",
      "नई क्षमताओं के उपयोग पर गहन मार्गदर्शन के लिए सहायता केंद्र देखें।"
    ],
    "bullets": [
      "नवीनतम उत्पाद अपडेट",
      "सुविधा में सुधार और समाधान",
      "वर्कफ़्लो संवर्द्धन"
    ],
    "links": [
      {
        "href": "/help",
        "label": "सहायता केंद्र पर वापस जाएँ"
      },
      {
        "href": "/blog",
        "label": "ब्लॉग अपडेट पढ़ें"
      },
      {
        "href": "/metadata",
        "label": "Metadata Studio खोलें"
      }
    ],
    "sections": [
      {
        "title": "ट्रैक रिलीज़",
        "paragraphs": [
          "प्रत्येक प्रविष्टि नई सुविधाओं, सुधारों और वर्कफ़्लो अपडेट को सूचीबद्ध करती है ताकि आप अद्यतित रह सकें।"
        ],
        "bullets": [
          "उत्पाद में सुधार",
          "वर्कफ़्लो संवर्द्धन",
          "स्थिरता और प्रदर्शन ठीक करता है"
        ]
      },
      {
        "title": "सूचित रहें",
        "paragraphs": [
          "अपने वर्कफ़्लो को अपडेट करने या नए टीम सदस्यों को शामिल करने से पहले हाल के परिवर्तनों की समीक्षा करें।"
        ],
        "bullets": [
          "अपनी टीम के साथ अपडेट साझा करें",
          "नए निर्यात विकल्पों की जाँच करें",
          "प्रशिक्षण सत्र की योजना बनाएं"
        ]
      }
    ],
    "faq": [
      {
        "q": "इसे कितनी बार अद्यतन किया जाता है?",
        "a": "अपडेट नई रिलीज़ शिप के रूप में पोस्ट किए जाते हैं।"
      },
      {
        "q": "मैं सुविधाओं का अनुरोध कहां कर सकता हूं?",
        "a": "ऐप के अंदर या सहायता केंद्र के माध्यम से फीडबैक साझा करें।"
      }
    ]
  }
};

export const APP_ROUTE_SEO_UI_COPY_HI = {
  "home": "होम",
  "faq": "सामान्य प्रश्न",
  "summaryTitle": "टीएल;डीआर",
  "sourcesTitle": "स्रोत",
  "sourcesIntro": "इस पेज के स्रोतों में नीचे लिंक किए गए Stocktag के आधिकारिक workflow, pricing और support पेज शामिल हैं।",
  "relatedLinks": "संबंधित लिंक",
  "workflowNotes": "वर्कफ़्लो नोट्स",
  "depthIntro": (title, keywordSummary) => `यह पृष्ठ उन योगदानकर्ताओं के लिए Stocktag के पूर्ण __hi_param_0__ वर्कफ़्लो का हिस्सा है, जिन्हें बड़े पैमाने पर विश्वसनीय आउटपुट की आवश्यकता होती है। यह ${keywordSummary} जैसे व्यावहारिक कदमों पर ध्यान केंद्रित करता है, ताकि टीमें मेटाडेटा गुणवत्ता को कम किए बिना तेजी से प्रकाशित कर सकें।`,
  "depthBody": "सुसंगत परिणामों के लिए, इस रूट को Metadata Studio के साथ जोड़ें, कीवर्ड ऑर्डर को जानबूझकर रखें, और निर्यात से पहले एक छोटा QA पास चलाएं। यह प्रक्रिया Adobe Stock, Shutterstock और अन्य बाज़ारों में खोज योग्यता को सुरक्षित रखने में मदद करती है।",
  "depthBullets": [
    "शीर्षक, विवरण और कीवर्ड के लिए दोहराए जाने योग्य टेम्पलेट का उपयोग करें।",
    "निर्यात से पहले प्रासंगिकता सत्यापित करें और कमजोर या डुप्लिकेट शब्दों को हटा दें।",
    "बेहतर खोज इरादे के साथ पुरानी फ़ाइलों को ट्रैक करें और ताज़ा करें।"
  ]
};


export default APP_ROUTE_SEO_CONTENT_HI;
